module.exports = __webpack_public_path__ + "img/title2-ja.7f83ddf7.png";